import { componentForArticleType } from './articleHelper';
import ArticleForm from './components/forms/articleForm';
import ListTeaser from './components/listTeaser';
import MapSection from './components/mapSection';
import OnePagerArticle from './components/articles/onePagerArticle';
import VerticalNavigation from './components/verticalNavigation';
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

function onePagerArticlesInit() {
  const $onePagerArticles = $('.one-pager');

  if ($onePagerArticles.length) {
    $onePagerArticles.each(function() {
      const $this = $(this);

      function articleTypeFromCssClasses(cssClasses) {
        if (cssClasses) {
          return cssClasses
            .replace('article-container', '')
            .replace('-section', '')
            .replace('one-pager', '')
            .trim();
        }

        return 'default';
      }

      ReactDOM.render(
        <OnePagerArticle
          articleId={$this.data('article-id')}
          articleType={articleTypeFromCssClasses($this.prop('class'))}
          hasSliderArticles={$this.data('slider-articles')}
        />,
        $this[0]
      );
    });

    if ($onePagerArticles.length > 1) {
      const verticalNavigation = document.createElement('div');

      $(verticalNavigation).appendTo('body');
      ReactDOM.render(<VerticalNavigation />, verticalNavigation);
    }
  }
}

function articleTypesInit(slideArticleType) {
  const $articles = $(`.${slideArticleType}-section`).not('.one-pager');

  if ($articles.length) {
    $articles.each(function() {
      const $this = $(this),
            slideArticleId = $this.data('article-id'),
            slideArticleLanguage = $this.data('article-lang');

      ReactDOM.render(
        componentForArticleType(slideArticleId, slideArticleType, slideArticleLanguage),
        $this[0]
      );
    });
  }
}

function defaultArticlesInit() {
  articleTypesInit('default');
}

function branchArticlesInit() {
  articleTypesInit('branch');
}

function consultantArticlesInit() {
  articleTypesInit('consultant');
}

function eventArticlesInit() {
  articleTypesInit('event');
}

function reportArticlesInit() {
  articleTypesInit('report');
}

function pressReleaseArticlesInit() {
  articleTypesInit('pressrelease');
}

function externalArticleInit() {
  articleTypesInit('external');
}

function landingpageInit() {
  articleTypesInit('landingpage');
}

function indexArticlesInit() {
  const $indexArticles = $('.article-index .article-container'),
        $articleFormContainers = $('.article-form-container');

  if ($indexArticles.length) {
    $indexArticles.each(function() {
      const $this = $(this);

      ReactDOM.render(<ListTeaser articleId={$this.data('article-id')} />, $this[0]);
    });
  }

  if ($articleFormContainers.length) {
    $articleFormContainers.each(function() {
      const $this = $(this);

      ReactDOM.render(
        <ArticleForm
          formId={$this.data('form-base-id')}
          contentArticleFormId={$this.data('content-article-form-id')}
        />,
        $this[0]
      );
    });
  }
}

// init with default `apiEndpoint="index"` for .map-section containers,
// currently only on the startpage, to display markers for all branches
// using the map on branch or consultant articles the branch id for
// the show api endpoint is needed.
function mapSectionInit() {
  const $mapSection = $('.map-section');

  if ($mapSection.length) {
    $mapSection.each(function() {
      const $this = $(this);
      let apiEndpoint = 'index';

      if ($this.hasClass('show-branch')) {
        apiEndpoint = `${$this.data('branchId')}`;
      }

      ReactDOM.render(<MapSection apiEndpoint={apiEndpoint} />, $this[0]);
    });
  }
}

// submit frontend tag select on change, i. e. on /news report index page
// if frontend tag filter is present
function submitFrontendTag() {
  const $indexFilterSearch = $('#index-filter-search'),
        $indexFilterSelect = $('.index-filter-select');

  if ($indexFilterSearch.length && $indexFilterSelect.length) {
    $indexFilterSelect.change(() => $indexFilterSearch.submit());
  }
}

// on articles there could be a fixed seal widget.
// if it is available, it should slide in from the right outside of the screen automatically.
// on clicking the close button it should disappear.
// this should not happen on small screens!
// QB-543
function fixedSealInit() {
  const isSmallWidth = document.body.clientWidth < 800,
        $sealFixed = $('.seal-fixed'),
        $sealMobileFixed = $('.seal-fixed.seal-mobile'),
        $closeSeal = $('.close-seal');

  function toggleSeal() {
    if ($sealFixed.length) {
      $sealFixed.toggleClass('seal-closed seal-opened');
    }
  }

  if (!isSmallWidth) {
    toggleSeal();
  }

  // QB-1128
  function toggleSealMobile() {
    if ($sealMobileFixed.length) {
      $sealMobileFixed.toggleClass('seal-closed seal-mobile-opened');
      setTimeout(() => {
        $sealMobileFixed.toggleClass('seal-mobile-fadein');
      }, 3000);
    }
  }

  if (isSmallWidth) {
    toggleSealMobile();
  }

  function closeSeal() {
    if ($sealFixed.length) {
      $sealFixed.removeClass('seal-opened seal-mobile-opened');
      $sealFixed.addClass('seal-closed');
    }
  }

  $closeSeal.on('click', () => {
    closeSeal();
  });
}

function articlesInit() {
  onePagerArticlesInit();
  defaultArticlesInit();
  branchArticlesInit();
  consultantArticlesInit();
  eventArticlesInit();
  reportArticlesInit();
  pressReleaseArticlesInit();
  externalArticleInit();
  landingpageInit();
  indexArticlesInit();
  mapSectionInit();
  submitFrontendTag();
  fixedSealInit();
}

export { articlesInit };



// WEBPACK FOOTER //
// ./articlesInit.js